module.exports = __webpack_public_path__ + "images/114_1024.jpg";